import i18n from 'Pods/Shared/I18n'

function getToggles(showCgtVerification, isMobile, locale) {
  return [{
    value: i18n.t('listingPage.filters.visibility.format', { ns: 'rails', lng: locale }),
    key: 'format',
  }, {
    value: i18n.t('listingPage.filters.visibility.price', { ns: 'rails', lng: locale }),
    key: 'price',
  }, showCgtVerification && {
    value: 'CGT Standard',
    key: 'cgtStandard',
  }, {
    value: i18n.t('listingPage.filters.visibility.type', { ns: 'rails', lng: locale }),
    key: 'type',
  }, {
    value: i18n.t('listingPage.filters.visibility.title', { ns: 'rails', lng: locale }),
    key: 'title',
  }, {
    value: i18n.t('listingPage.filters.visibility.quickActionsOnHover', { ns: 'rails', lng: locale }),
    key: 'quickActionsOnHover',
  }, !isMobile && {
    value: i18n.t('listingPage.filters.visibility.suggestions', { ns: 'rails', lng: locale }),
    key: 'suggestions',
  }].filter(Boolean)
}

export default getToggles
